import {
    type AppDatabase,
    useAppLiveQuery,
    useAppLiveQueryState,
} from '../../db';
import { useStaffSessionStore } from '../../store';

const queryCurrentStaff = (staffId: string) => (state: AppDatabase) =>
    state.staff
        .where('id')
        .equals(staffId)
        .and((staff) => !staff.deleted)
        .first();

export const useUserInfo = () => {
    const staffId = useStaffSessionStore((staff) => staff.staffId) ?? '';

    return useAppLiveQuery(queryCurrentStaff(staffId), []);
};

export const useUserInfoState = () => {
    const staffId = useStaffSessionStore((staff) => staff.staffId) ?? '';

    return useAppLiveQueryState(queryCurrentStaff(staffId), []);
};
